export const darkToastStyle = {
  backgroundColor: '#333',
  color: '#fff',
  borderRadius: '10px',
};
